import classes from './fdpUpdatedScreen.module.scss';
import provisionalForecast from '../../assets/icons/provisionalForecast.svg';
import line_chart from '../../assets/icons/line_chart.svg';
import unconstrained from '../../assets/icons/unconstrained.svg';
import constrained from '../../assets/icons/contrained.svg';

import { useNavigate } from 'react-router-dom';
import { screenDataInterface } from 'Interfaces/navigationScreenDataInterface';

const FDPUpdatedScreen = () => {
  const navigate = useNavigate();

  const screenData: screenDataInterface = [
    {
      location: 'sales_plan_updated',
      img: line_chart,
      label: 'Sales Plan (15-Month)',
      disabled: false,
    },
    {
      location: 'unconstrained_forecast',
      img: unconstrained,
      label: 'Unconstrained Forecast (15-Month)',
      disabled: false,
    },
    {
      location: 'constrained_forecast',
      img: constrained,
      label: 'Constrained Forecast (15-Month)',
      disabled: false,
    },
    {
      location: 'unconstrained_bulk_edit',
      img: '',
      label: 'Unconstrained Forecast Bulk Edit',
      disabled: false,
    },
    {
      location: 'sales_plan_bulk_edit',
      img: '',
      label: 'Sales Plan Bulk Edit',
      disabled: false,
    },
    {
      location: 'provisonal_forecast_updated',
      img: provisionalForecast,
      label: 'Provisional Forecast (2025)',
      disabled: false,
    },
    {
      location: 'ooc',
      img: '',
      label: 'Out of Cycle',
      disabled: false,
    },
  ];

  return (
    <div className={classes.fdpScreenContainer}>
      {screenData.map((data, index) => {
        return (
          <div
            onClick={() => {
              if (!data.disabled) {
                navigate(data.location);
              }
            }}
            key={index}
          >
            <div className={data.disabled ? classes.btnSectionDisabled : classes.btnSection}>
              <div>
                <div className={classes.imgBackground}></div>
                {data.img ? (
                  <img src={data.img} alt={`${data.label} icon`} />
                ) : (
                  <span className={classes.iconPlaceholder}>{data.label.charAt(0)}</span>
                )}
              </div>
              <p>{data.label}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FDPUpdatedScreen;
